<template>
  <b-card no-body>
    <div id="map" />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { createMap, drawPoints } from 'maplibre-gl-js-amplify'

export default {
  components: {
    BCard,
  },
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
  },
  watch: {
    coordinates: {
      deep: true,
      handler(newVal) {
        this.coordinates = newVal
      },
    },
  },
  created() {
    this.initializeMap()
  },
  methods: {
    async initializeMap() {
      const map = await createMap({
        container: 'map', // An HTML Element or HTML element ID to render the map in https://maplibre.org/maplibre-gl-js-docs/api/map/
        center: [this.coordinates[0], this.coordinates[1]], // [Longitude, Latitude]
        markerCoordinates: [this.coordinates[0], this.coordinates[1]],
        zoom: 16,
      })
      map.on('load', () => {
        drawPoints('mySourceName', // Arbitrary source name
          [
            {
              coordinates: [this.coordinates[0], this.coordinates[1]], // [Longitude, Latitude]
            },
          ], // An array of coordinate data, an array of Feature data, or an array of [NamedLocations](https://github.com/aws-amplify/maplibre-gl-js-amplify/blob/main/src/types.ts#L8)
          map,
          {
            showCluster: true,
            unclusteredOptions: {
              showMarkerPopup: true,
            },
            clusterOptions: {
              showCount: true,
            },
          })
      })
    },
  },
}
</script>

<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 450px;
  }
}
</style>
